// extracted by mini-css-extract-plugin
module.exports = {"alfredTools":"kCkpzVRT","leftTools":"KdWbFnPE","toolsWrapper":"M9aEZCie","researchDropdowns":"KOpaxO11","researchDropdownsDivider":"cQmM71Zd"};